<template>
  <div>
    <v-col align="left">
      <v-form ref="form" lazy-validation>
        <div class="preference-heading">Full Name:</div>
        <v-row class="ma-0 mt-2">
          <v-text-field
            v-model="name"
            outlined
            dense
            :rules="[rules.required, rules.notEmpty]"
          />
        </v-row>
        <div class="preference-heading">Email:</div>
        <v-row class="ma-0 mt-2">
          <v-text-field v-model="email" outlined dense :rules="[rules.email]" />
        </v-row>
      </v-form>
      <!-- <div class="preference-heading">Mobile:</div>
      <v-row class="ma-0 mt-2">
        <v-text-field v-model="mobile" disabled outlined dense />
      </v-row> -->
      <v-btn
        color="#506CFF"
        dark
        exact
        :loading="userLoading"
        class="btn-text mt-4"
        @click="setUserDetails"
      >
        Save Details
      </v-btn>
    </v-col>
  </div>
</template>

<script>
  import authToken from "../../common/authToken";
  import RULES from "../../common/fieldRules";
  import Axios from "../../api/BaseAxios";
  import { API_CLIENT_URL, ROUTER_URL } from "../../constants/urls";

  export default {
    name: "EditAccountInfo",
    components: {},
    data() {
      return {
        rules: RULES,
        name:
          authToken.decodedToken()["first_name"] +
          " " +
          authToken.decodedToken()["last_name"],
        email: authToken.decodedToken()["email"],
        mobile: "",
        userLoading: false,
      };
    },
    created() {},
    computed: {},
    watch: {},
    methods: {
      setUserDetails() {
        if (this.$refs.form.validate()) {
          this.userLoading = true;
          const successHandler = (res) => {
            console.log(res);
            localStorage.setItem("token", res.data.token);

            authToken.deleteCookie(`accesstoken`);

            document.cookie = `accesstoken=${res.data.token}; domain=.eblity.com`;

            this.userLoading = false;
            this.$store.dispatch("snackBar/showToast", {
              message: "Your Account Information is updated!!",
              color: "S",
            });
            this.$router.push({
              name: ROUTER_URL.publicUser.children.myMembership.name,
            });
          };

          const failureHandler = (res) => {
            console.log(res);
            this.userLoading = false;
          };

          var index = this.name.indexOf(" ");
          var first_name = this.name.substr(0, index);
          var last_name = this.name.substr(index + 1) + " ";

          let params = {
            first_name: first_name,
            last_name: last_name,
            email: this.email,
          };

          Axios.request_POST(
            API_CLIENT_URL.userDetails,
            params,
            {},
            successHandler,
            failureHandler
          );
        }
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .preference-heading {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
  }
  .btn-text {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    max-width: 570px;
  }
</style>
